import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { FaUsers, FaChartLine, FaHandshake, FaCity } from "react-icons/fa";
import CountUp from "react-countup";
const Cta = () => {
     const stats = [
        { icon: <FaUsers size={40} color="rgb(52, 81, 159)" />, value: 300, suffix: "+", label: "Customers" },
        { icon: <FaChartLine size={40} color="rgb(52, 81, 159)" />, value: 26, label: "Brands" },
        { icon: <FaHandshake size={40} color="rgb(52, 81, 159)" />, value: 50, label: "Suppliers" },
        { icon: <FaCity size={40} color="rgb(52, 81, 159)" />, value: 5, label: "Cities" },
    ];
    const [startCount, setStartCount] = useState(false);
    const sectionRef = useRef(null);
    useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setStartCount(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.5 }
            );
            if (sectionRef.current) {
                observer.observe(sectionRef.current);
            }
            return () => observer.disconnect();
        }, []);

    return (
        <React.Fragment>
            <section ref={sectionRef} className=" py-5 bg-white position-relative" >
                <div className="bg-overlay bg-overlay-pattern opacity-50"></div>
                <Container>
                    <Row className="align-items-center gy-4">
                        {stats.map((stat, index) => (
                            <Col key={index} md={3} sm={6} className="d-flex flex-column align-items-center ">
                                {stat.icon}
                                <h2 className="mt-2 " style={{color:"rgb(52, 81, 159)"}}>
                                    {startCount ? (
                                        <CountUp start={0} end={stat.value} duration={2.5} suffix={stat.suffix || ""} />
                                    ) : (
                                        "0"
                                    )}
                                </h2>
                                <p style={{color:"rgb(52, 81, 159)"}}>{stat.label}</p>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Cta;